module.exports = __webpack_public_path__ + "img/nocamera-tips-blank.9422c8d0.png";